<template>
  <div
    v-if="number"
    class="rounded-full bg-gradient-to-b flex items-center justify-center text-base font-bold text-white"
    :class="[{'border-4':isActive}, bgColor]"
    :style="`width: ${props.size}; height: ${props.size}`"
  >
    <QBtn
      :label="number"
      rounded
      unelevated
      class="h-full w-full"
    />
  </div>
  <div
    v-else
    class="rounded-full border-1 border-[#586688] justify-self-center"
    :style="`width: ${props.size}; height: ${props.size}`"
  />
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
  number: {
    type: Number,
    default: null
  },
  size: {
    type: String,
    default: '40px'
  },
  isActive: {
    type: Boolean,
    default: false
  }
})

const bgColor = computed(() => {
  if (1 <= props.number && props.number <= 10) {
    return 'from-[#FF7B7B] to-[#BC2626]'
  }
  if (11 <= props.number && props.number <= 20) {
    return 'from-[#7BC0FF] to-[#2635BC]'
  }
  if (21 <= props.number && props.number <= 30) {
    return 'from-[#FCFF7B] to-[#BC6526]'
  }
  if (31 <= props.number && props.number <= 40) {
    return 'from-[#7BFF88] to-[#0C8A3E]'
  }
  if (41 <= props.number && props.number <= 45) {
    return 'from-[#CD7BFF] to-[#6518A1]'
  }
})
</script>
